import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function InterestsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"interests"}/>
}
